import ACTIONS_TYPES from '../../constants/types';
import { IUserState } from '../reducers/userReducer';

interface SetAccountDataAction {
  type: typeof ACTIONS_TYPES.SET_ACCOUNT_DATA;
  payload: IUserState;
}

interface ResetAccountDataAction {
  type: typeof ACTIONS_TYPES.LOGOUT;
}

const setAccountData = (userData: IUserState): SetAccountDataAction => {
  return {
    type: ACTIONS_TYPES.SET_ACCOUNT_DATA,
    payload: {
      ...userData,
    },
  };
};

const resetAccountData = (): ResetAccountDataAction => {
  return {
    type: ACTIONS_TYPES.LOGOUT,
  };
};

export type UserActionTypes = ResetAccountDataAction & SetAccountDataAction;

export default {
  setAccountData,
  resetAccountData,
};
